import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './Button.scss'

const Button = ({ className, kind, onClick, children, ...moreProps }) => {
  const compClassName = classnames('frontend-btn', className, {
    [`frontend-btn__${kind}`]: !!kind
  })

  return (
    <button type='button' className={compClassName} onClick={onClick} {...moreProps}>{children}</button>
  )
}

Button.propTypes = {
  className: PropTypes.string,
  kind: PropTypes.oneOf(['main', 'secondary']),
  onClick: PropTypes.func,
  children: PropTypes.node
}

export default Button
